module.exports = __webpack_public_path__ + "static/sport/logo.11139dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/logo.png
// module id = nGNq
// module chunks = 0